import { useSelector } from 'react-redux';
import { isDefined } from 'utils/tsHelpers';
import { EMPTY_VALUE_MESSAGE } from '../../../../helpers';
import { selectValidationMessages } from '../../../../selectors';
import { useTranslation } from '../../../../../hooks/useTranslation';

export const useMultiSelectErrorMessage = (): string | undefined => {
  const { t } = useTranslation();
  const validationMessages = useSelector(selectValidationMessages);
  return isDefined(validationMessages) && validationMessages.includes(EMPTY_VALUE_MESSAGE)
    ? t('errorMessages.empty')
    : undefined;
};
